<script lang="ts" setup>
import IconeRoundMenu from '~icons/ic/round-menu'
import IconeRoundClose from '~icons/ic/round-close'

const props = defineProps<{
  isOpen: boolean
}>()

defineEmits<{
  toggle: void
}>()
</script>

<template>
  <transition name="scale" mode="out-in">
    <IconeRoundClose v-if="isOpen" class="text-4xl cursor-pointer" @click="$emit('toggle')" />
    <IconeRoundMenu v-else class="text-4xl cursor-pointer" @click="$emit('toggle')" />
  </transition>
</template>

<style>
</style>
